import { GameConstants } from './../../../GameConstants';
import { GameVars } from "../../../GameVars";
import * as Anuto from "../../../../engine/src";

export class TurretInfo extends Phaser.GameObjects.Container {

    private background: Phaser.GameObjects.Image;
    private turretName: Phaser.GameObjects.Text;
    private turretIcon: Phaser.GameObjects.Image;
    private turretImage: Phaser.GameObjects.Image;
    private statTexts: Phaser.GameObjects.Text[];
    private patch: Phaser.GameObjects.Graphics;

    constructor(scene: Phaser.Scene) {
        super(scene);

        this.y = 200;

        this.background = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "info_box");
        this.background.setOrigin(0);
        this.add(this.background);

        this.turretName = new Phaser.GameObjects.Text(this.scene, this.background.width / 2 + 5, 2,  "", {fontFamily: "Rubik-Bold", fontSize: "22px", color: "#563744", align: "center"});
        this.turretName.setOrigin(.5, 0);
        this.add(this.turretName);

        this.turretIcon = new Phaser.GameObjects.Image(this.scene, 27, 59, "texture_atlas_1");
        this.turretIcon.setOrigin(0);
        this.add(this.turretIcon);

        this.turretImage = new Phaser.GameObjects.Image(this.scene, this.background.width / 2 + 5, 70, "texture_atlas_2");
        this.add(this.turretImage);

        this.statTexts = [];

        this.visible = false;
    }

    public show(key: string, i: number, x: number, y: number): void {

        for (let i = 0; i < this.statTexts.length; i++) {
            this.statTexts[i].destroy();
        }

        this.statTexts = [];

        this.visible = true;
        this.x = x + 40;
        this.y = y - this.background.height + 40;

        let upgrade = GameVars.gameData.upgradesUnlocked[key];

        this.turretName.setText(GameVars.turretsData[key].name.toUpperCase());
        this.turretIcon.setFrame("icon_info_" + (i + 1));
        this.turretImage.setFrame("tower_image_" + (i + 1) + "_" + (upgrade === 0 ? 1 : upgrade));

        let keys = Object.keys(GameVars.turretsData[key].attributes);
        let count = 0;

        for (let i = 0; i < Math.min(keys.length, 4); i++) {

            if (keys[i] === Anuto.GameConstants.ATTRIBUTE_PRICE_UPGRADE) {
                continue;
            }

            if (GameVars.turretsData[key].attributes[keys[i]][0] === GameVars.turretsData[key].attributes[keys[i]][1]) {
                continue;
            }

            let text = keys[i].toUpperCase();

            switch (keys[i]) {
                case Anuto.GameConstants.ATTRIBUTE_EXPLOSION_RANGE:
                    text = "EXP. RANGE";
                    break;
                case Anuto.GameConstants.ATTRIBUTE_MAX_NUM_MINES:
                    text = "MINES";
                    break;
                case Anuto.GameConstants.ATTRIBUTE_TELEPORT_DISTANCE:
                    text = "DISTANCE";
                    break;
                default:
                    break;
            }

            let stat1 = GameVars.turretsData[key].attributes[keys[i]][0];
            let stat2 = GameVars.turretsData[key].attributes[keys[i]][1];
            let stat3 = GameVars.turretsData[key].attributes[keys[i]][2];

            if (key === Anuto.GameConstants.TURRET_FIRE && keys[i] === Anuto.GameConstants.ATTRIBUTE_DAMAGE) {
                text = "DPS";
                stat1 = GameVars.turretsData[key].extraAttributes.DPS[0];
                stat2 = GameVars.turretsData[key].extraAttributes.DPS[1];
                stat3 = GameVars.turretsData[key].extraAttributes.DPS[2];
            }

            let statText = new Phaser.GameObjects.Text(this.scene, 25, 134 + count * 22, text, {fontFamily: "Rubik-Bold", fontSize: "15px", color: "#563744", align: "center"});
            statText.setOrigin(0, .5);
            this.add(statText);
            this.statTexts.push(statText);

            statText = new Phaser.GameObjects.Text(this.scene, 170, 134 + count * 22, stat1, {fontFamily: "Rubik-Bold", fontSize: "14px", color: "#cc6633", align: "center"});
            statText.setOrigin(.5);
            this.add(statText);
            this.statTexts.push(statText);

            statText = new Phaser.GameObjects.Text(this.scene, 215, 134 + count * 22, stat2, {fontFamily: "Rubik-Bold", fontSize: "14px", color: "#8a4727", align: "center"});
            statText.setOrigin(.5);
            this.add(statText);
            this.statTexts.push(statText);

            statText = new Phaser.GameObjects.Text(this.scene, 260, 134 + count * 22, stat3, {fontFamily: "Rubik-Bold", fontSize: "14px", color: "#563744", align: "center"});
            statText.setOrigin(.5);
            this.add(statText);
            this.statTexts.push(statText);

            count++;
        }
        
        if (key === Anuto.GameConstants.TURRET_BZZT) {

            let text = "SLOWDOWN";
            let stat1 = GameVars.turretsData[key].duration[0];
            let stat2 = GameVars.turretsData[key].duration[1];
            let stat3 = GameVars.turretsData[key].duration[2];

            let statText = new Phaser.GameObjects.Text(this.scene, 25, 134 + count * 22, text, {fontFamily: "Rubik-Bold", fontSize: "15px", color: "#563744", align: "center"});
            statText.setOrigin(0, .5);
            this.add(statText);
            this.statTexts.push(statText);

            statText = new Phaser.GameObjects.Text(this.scene, 170, 134 + count * 22, stat1, {fontFamily: "Rubik-Bold", fontSize: "14px", color: "#cc6633", align: "center"});
            statText.setOrigin(.5);
            this.add(statText);
            this.statTexts.push(statText);

            statText = new Phaser.GameObjects.Text(this.scene, 215, 134 + count * 22, stat2, {fontFamily: "Rubik-Bold", fontSize: "14px", color: "#8a4727", align: "center"});
            statText.setOrigin(.5);
            this.add(statText);
            this.statTexts.push(statText);

            statText = new Phaser.GameObjects.Text(this.scene, 260, 134 + count * 22, stat3, {fontFamily: "Rubik-Bold", fontSize: "14px", color: "#563744", align: "center"});
            statText.setOrigin(.5);
            this.add(statText);
            this.statTexts.push(statText);

            count++;
        }

        if (this.patch) {
            this.patch.destroy();
        }
        
        this.patch = new Phaser.GameObjects.Graphics(this.scene);
        this.patch.setPosition(170, 134 + (count - .5) * 22);
        this.patch.fillStyle(0xfffdbe);
        this.patch.fillRect(0, 0, 100, (4 - count) * 22);
        this.add(this.patch);
    }

    public hide(): void {

        this.visible = false;
    }
}
